"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hideAttrsFromList = void 0;
/** Takes user attributes and applies hideFromList: true to all of them **/
const hideAttrsFromList = (attrs) => {
    return Object.fromEntries(Object.entries(attrs).map(([key, attr]) => {
        return [key, { ...attr, hideFromList: true }];
    }));
};
exports.hideAttrsFromList = hideAttrsFromList;
